module.exports = __webpack_public_path__ + "img/st.0970763b.svg";